// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['zh_TW']  = {
  "name": "zh_TW",
  "day": {
    "abbrev": [
      "日",
      "一",
      "二",
      "三",
      "四",
      "五",
      "六"
    ],
    "full": [
      "週日",
      "週一",
      "週二",
      "週三",
      "週四",
      "週五",
      "週六"
    ]
  },
  "month": {
    "abbrev": [
      " 1月",
      " 2月",
      " 3月",
      " 4月",
      " 5月",
      " 6月",
      " 7月",
      " 8月",
      " 9月",
      "10月",
      "11月",
      "12月"
    ],
    "full": [
      "一月",
      "二月",
      "三月",
      "四月",
      "五月",
      "六月",
      "七月",
      "八月",
      "九月",
      "十月",
      "十一月",
      "十二月"
    ]
  },
  "meridiem": [
    "上午",
    "下午"
  ],
  "date": "%Y年%m月%d日",
  "time24": "%H時%M分%S秒",
  "dateTime": "%Y年%m月%d日 (%A) %H時%M分%S秒",
  "time12": "%p %I時%M分%S秒",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

